import 'autotrack/lib/plugins/event-tracker';
import 'autotrack/lib/plugins/outbound-link-tracker';
import 'autotrack/lib/plugins/max-scroll-tracker';

const GA_UA = process.env.NODE_ENV === 'development' ? 'UA-85600241-2' : 'UA-85600241-1';

if (typeof window !== 'undefined') {
  window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
  ga('create', GA_UA, 'auto');

  // plugins
  ga('require', 'eventTracker', {
    attributePrefix: 'data-ga-'
  });
  ga('require', 'outboundLinkTracker');
  ga('require', 'maxScrollTracker');

  ga('send', 'pageview');
}



// WEBPACK FOOTER //
// ./src/lib/ga.js